import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxGroupProps as CheckboxGroupCopyProps } from 'antd/lib/checkbox';

export type CheckboxGroupProps = CheckboxGroupCopyProps;

const ProCheckboxGroup: React.FC<CheckboxGroupProps> = (props) => {
  const { children, ...resProps } = props;
  return (
    <Checkbox.Group { ...resProps }>{children}</Checkbox.Group>
  );
};

export default ProCheckboxGroup;